<template>
  <div>
    <iframe id="youtube" width="100%" src="https://www.youtube.com/embed/9r1dGUUFPQE?rel=0&showinfo=0&modestbranding=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: 'Youtube',
  methods: {
    resize: function(){
      var youtube = document.getElementById("youtube");
      youtube.style.height = ~~(window.innerWidth * 0.5625) + "px";
    }
  },
  mounted: function(){
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style scoped>
.full{
    width: 100%;
    height: 100vh;
    background: #eee;
}

</style>
